// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__3K9B5","icon":"style_icon__bl-5f"};